import React from "react";
import PropTypes from "prop-types";
import { Section } from "../../../../components/CustomLayout/CustomLayoutStyles";
import Text from "../../../../components/Common/Text";
import { Table, Td } from "../../styles/tableStyles";
import Titulo from "../../shared/Titulo";
const PrecertificacionAdjuntos = (props) => {
  const { documentos, onArchivoSeleccionado, onError } = props;

  const hadleArchivoSeleccionado = (e, documento) => {
    const file = e.target.files[0];

    if (!file) {
      onError && onError("No se ha seleccionado ningún archivo.");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      onError &&
        onError(
          "El archivo seleccionado es demasiado grande. El tamaño máximo permitido es 5 MB."
        );
      return;
    }

    if (!["application/pdf", "image/jpeg", "image/png"].includes(file.type)) {
      onError &&
        onError(
          "El archivo seleccionado no es un PDF o una imagen válida (JPEG/PNG)."
        );
      return;
    }

    onArchivoSeleccionado && onArchivoSeleccionado(documento, file);
  };

  return (
    <>
      <Titulo titulo={"Documentos"} />

      <Section flexDirection={"column"} align={"center"}>
        <Table width={"95%"}>
          <tbody>
            {documentos.map((documento, index) => {
              return (
                <tr key={index}>
                  <Td width={"40%"} backgroundColor={"#f0f0f0"}>
                    <Text weight={"bold"} size={"12px"} textAlign={"start"}>
                      {`${documento.nombreDocumento} 
                      ${
                        documento.cobertura ? documento.nombreProcedimiento : ""
                      } ${documento.requerido ? "(*)" : ""}`}
                    </Text>
                  </Td>
                  <Td width={"60%"}>
                    <input
                      type="file"
                      accept="application/pdf, image/*"
                      onChange={(e) => hadleArchivoSeleccionado(e, documento)}
                    />
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Section>
    </>
  );
};

PrecertificacionAdjuntos.propTypes = {
  documentos: PropTypes.arrayOf(
    PropTypes.shape({
      nombreDocumento: PropTypes.string.isRequired,
      requerido: PropTypes.bool
    })
  ).isRequired,
  onArchivoSeleccionado: PropTypes.func.isRequired
};

export default PrecertificacionAdjuntos;
